module.exports = __webpack_public_path__ + "img/QA-main.3c399410.png";